import { styled } from '@mui/material';
import { GivelifyModal } from '../modal';

export const StyledModal = styled(GivelifyModal)(({ theme }) => ({
    '& .MuiPaper-root': {
        maxWidth: '512px',
    },

    '& .modal-icon': {
        marginBottom: '16px',
        marginTop: '8px',
    },

    '& .modal-actions': {
        margin: '24px 0 24px 0',
        gap: '16px',
        [theme.breakpoints.up('mobile')]: {
            flexWrap: 'nowrap',
        },

        '& button': {
            minWidth: '208px',
            fontSize: '16px',

            [theme.breakpoints.down('mobile')]: {
                minWidth: '248px',
                width: '100%',
            },
        },
    },
}));

export const ContentContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',

    '& .description': {
        fontSize: '14px',
        textAlign: 'center',
    },
}));
